import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import axios from "axios";
import { InputMain } from "components";
import { SeeYourEvent } from "./seeyourEvent";
import {
  bankAccountActions,
  httpRequestsOnErrorsActions,
  httpRequestsOnLoadActions,
  httpRequestsOnSuccessActions,
} from "store";
import {
  FindError,
  FindLoad,
  FindSuccess,
  ProfileInfo,
  SaveParams,
} from "utils";
import { Stepper } from "./stepper";
import { CELEBRATION } from "./constants";
import { UPLOAD_FUNDRAISER_IMAGE } from "../../fundraisers/fragments/constants";
import { fundraiserService } from "../../../store/fundraiser/fundraiser.service";

const ACTION_TYPE = "CONNECT_BANK_ACCOUNT";

export const ConnectBankAccount = () => {
  const [loading, setLoading] = useState(false);
  const [successCreatingEvent, setSuccessCreatingEvent] = useState(false);
  const location = useLocation();
  const navigator = useNavigate();
  const info = location?.state;
  const { handleSubmit, control, reset, clearErrors } = useForm();
  const dispatch = useDispatch();
  const { myProfile } = ProfileInfo();
  const connectLoading = FindLoad(ACTION_TYPE);
  const connectError = FindError(ACTION_TYPE);
  const connectSuccess = FindSuccess(ACTION_TYPE);

  useEffect(() => {
    if (info?.bankAccount) {
      reset(info?.bankAccount);
    }
  }, [info]);

  const createEvent = async () => {
    const images = info?.celebrationDetails?.images || [];
    const endDate = new Date(info?.celebrationDetails?.endDate);
    endDate.setHours(23, 59, 59, 999);
    const celebrationDate = new Date(info?.celebration?.celebrationDate);
    celebrationDate.setHours(23, 59, 59, 999);

    const sendData = {
      ...info?.celebration,
      ...info?.celebrationDetails,
      endDate,
      celebrationDate,
      charities: [],
      type: CELEBRATION,
    };

    setLoading(true);

    if (images.length > 0) {
      const formData = new FormData();
      const endpoint = `/files/uploadMany`;
      images.forEach((i) => formData.append("files", i));

      try {
        dispatch(
          httpRequestsOnLoadActions.appendLoading(UPLOAD_FUNDRAISER_IMAGE)
        );
        const res = await axios.post(endpoint, formData, { auth: true });
        sendData.images = res?.data;
      } catch (e) {
        SaveParams(location?.pathname, navigator, {
          ...info,
          step: 2,
        });
      } finally {
        dispatch(
          httpRequestsOnLoadActions.removeLoading(UPLOAD_FUNDRAISER_IMAGE)
        );
      }
    }

    fundraiserService
      .createFundraiserService(sendData)
      .then(() => {
        // navigator(`/event/${res?.data?.id}`);
        setSuccessCreatingEvent(true);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (connectSuccess?.type) {
      if (+info?.keepPercent !== 100) {
        const params = {
          ...info,
          step: 7,
        };
        SaveParams(location?.pathname, navigator, params);
      } else {
        createEvent();
      }

      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
    }
  }, [connectSuccess, info]);

  useEffect(() => {
    return () => {
      clearErrors();
      dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
    };
  }, []);

  const handleCreate = (data) => {
    const params = {
      ...info,
    };

    dispatch(
      bankAccountActions.connectBankAccount(data, myProfile?.pmtAccount?._id)
    );

    params.bankAccount = {
      ...data,
    };
    SaveParams(location?.pathname, navigator, params);
  };

  return (
    <>
      {!successCreatingEvent ? (
        <form
          className="in-celebration-box"
          onSubmit={handleSubmit(handleCreate)}
        >
          <div className="in-celebration-content">
            <div className="container">
              <div className="in-celebration-form-wrapper ConnectBankAccount-wrapper">
                <div className="in-celebration-form-header">
                  <p className="in-celebration-form-header-title">
                    Connect Your Bank Account
                  </p>
                </div>

                <div className="in-celebration-form-content">
                  <InputMain
                    className="celebration-input"
                    name="accountNumber"
                    type="number"
                    control={control}
                    placeholder="Enter your bank account number"
                    labelHeader="Bank Account Number"
                    rules={{
                      required: "Bank account number is required",
                      minLength: {
                        value: 8,
                        message:
                          "Bank Account Number must be minimum 8 characters long",
                      },
                      maxLength: {
                        value: 17,
                        message:
                          "SSN last 4 numbers must be maximum 17 characters long",
                      },
                    }}
                  />

                  <InputMain
                    className="celebration-input"
                    name="routingNumber"
                    control={control}
                    type="number"
                    placeholder="Provide your bank's routing number"
                    labelHeader="Routing Number"
                    rules={{
                      required: "Routing number is required",
                      minLength: {
                        value: 9,
                        message: "Routing number must be 9 characters long",
                      },
                      maxLength: {
                        value: 9,
                        message: "Routing number must be 9 characters long",
                      },
                    }}
                  />

                  <p className="error-message">{connectError?.error}</p>
                </div>
              </div>
            </div>
          </div>
          <Stepper
            loading={connectLoading || loading}
            isCompleted={+info?.keepPercent === 100}
          />
        </form>
      ) : (
        <SeeYourEvent />
      )}
    </>
  );
};
